class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


//Remove bundle products from cart drawer

document.addEventListener('click', async function (e) {
  const btn = e.target.closest('.cart-remove-button.cus-drawer-remove');
  if (!btn) return;

  const clickedItem = btn.closest('.cus-cart-drawer[data-cart-item]');
  if (!clickedItem) return;

  const timestamp = clickedItem.getAttribute('data-timestamp');
  if (!timestamp) return; // normal item → let Dawn handle

  try {
    // NEW — Add timestamp attribute/class to drawer
    const drawerEl = document.querySelector('.cus-cart-drawer');
    if (drawerEl) {
      drawerEl.setAttribute('data-last-removed-timestamp', timestamp); // attribute
      drawerEl.classList.add('has-timestamp-remove'); // optional flag class
    }
    // Get Current Cart
    const cart = await fetch('/cart.js').then(r => r.json());
    const updates = {};
    
    // Find Siblings (Same Timestamp) Exclude Clicked Row
    cart.items.forEach((item, i) => {
      if (!item.properties || item.properties.__timestamp != timestamp) return;
      const domItem = document.querySelectorAll('.cus-cart-drawer[data-cart-item]')[i];
      if (domItem === clickedItem) return;
      updates[item.key] = 0;
    });

    // Remove Siblings
    if (Object.keys(updates).length > 0) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
    }
    // Trigger Dawn refresh event
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    // Refresh Cart Drawer (no reload)
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      const res = await fetch('/cart?section_id=cart-drawer');
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newDrawer = doc.querySelector('cart-drawer');
      if (newDrawer) {
        drawer.innerHTML = newDrawer.innerHTML;
        setTimeout(() => {
          var qty = document.querySelector(".drawer__inner").getAttribute("total-items");
          console.log("qty =",qty);
          document.querySelector(".cart-count-bubble span[aria-hidden='true']").innerHTML = qty;
        }, 100);
        if (newDrawer.classList.contains('is-empty')) {
          drawer.classList.add('is-empty');
        } else {
          drawer.classList.remove('is-empty');
        }
      }
    }
    // Refresh Cart Page
    if (window.location.pathname === '/cart') {
      const res = await fetch('/cart?section_id=main-cart-items');
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newCart = doc.querySelector('#MainCartItems');

      const currentCart = document.querySelector('#MainCartItems');
      if (newCart && currentCart) {
        currentCart.innerHTML = newCart.innerHTML;
      }
    }

  } catch (err) {
    console.error('Grouped timestamp remove failed:', err);
  }

});


// comman button delete all items
document.addEventListener('click', async function (e) {

  const btn = e.target.closest('.bundle-remove-all');
  if (!btn) return;

  e.preventDefault();

  const timestamp = btn.dataset.timestamp;
  if (!timestamp) return;

  try {

    const cart = await fetch('/cart.js').then(r => r.json());
    const updates = {};

    cart.items.forEach(item => {
      if (item.properties && item.properties.__timestamp == timestamp) {
        updates[item.key] = 0;
      }
    });

    if (!Object.keys(updates).length) return;

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });

    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

  } catch (err) {
    console.error(err);
  }
  document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    // Refresh Cart Drawer (no reload)
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      const res = await fetch('/cart?section_id=cart-drawer');
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newDrawer = doc.querySelector('cart-drawer');
      if (newDrawer) {
        drawer.innerHTML = newDrawer.innerHTML;
        setTimeout(() => {
          var qty = document.querySelector(".drawer__inner").getAttribute("total-items");
          console.log("qty =",qty);
          document.querySelector(".cart-count-bubble span[aria-hidden='true']").innerHTML = qty;
        }, 100);
        if (newDrawer.classList.contains('is-empty')) {
          drawer.classList.add('is-empty');
        } else {
          drawer.classList.remove('is-empty');
        }
      }
    }
    // Refresh Cart Page
    if (window.location.pathname === '/cart') {
      const res = await fetch('/cart?section_id=main-cart-items');
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newCart = doc.querySelector('#MainCartItems');

      const currentCart = document.querySelector('#MainCartItems');
      if (newCart && currentCart) {
        currentCart.innerHTML = newCart.innerHTML;
      }
    }

});